import React, { useState } from 'react'
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material/styles'
import Markdown from '../util/Markdown'
import UserOnboarding from './sections/UserOnboarding.md'
import RotationsSchedules from './sections/RotationsSchedules.md'
import EscalationPolicies from './sections/EscalationPolicies.md'
import ServiceDocs from './sections/ServiceDocs.md'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
  },
  sidebarCard: {
    height: '100%',
    overflowY: 'auto',
  },
  contentCard: {
    height: '100%',
    overflowY: 'auto',
  },
  selectedItem: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.action.selected,
  },
  contentContainer: {
    maxWidth: '100%',
  },
}))

type DocSection = {
  id: string
  title: string
  content: string
}

const sections: DocSection[] = [
  {
    id: 'user-onboarding',
    title: 'User Onboarding',
    content: UserOnboarding,
  },
  {
    id: 'rotations-schedules',
    title: 'Rotations and Schedules',
    content: RotationsSchedules,
  },
  {
    id: 'escalation-policies',
    title: 'Escalation Policies',
    content: EscalationPolicies,
  },
  {
    id: 'service',
    title: 'Service Configuration',
    content: ServiceDocs,
  },
]

export default function Docs(): JSX.Element {
  const classes = useStyles()
  const [selectedSection, setSelectedSection] = useState<DocSection>(
    sections[0],
  )

  return (
    <div className={classes.root}>
      <Grid container spacing={2} style={{ height: '100%' }}>
        {/* Sidebar */}
        <Grid item xs={12} md={3} style={{ height: '100%' }}>
          <Card className={classes.sidebarCard} variant='outlined'>
            <CardContent style={{ padding: 0 }}>
              <Typography
                variant='h6'
                component='div'
                style={{ padding: '16px' }}
              >
                Documentation
              </Typography>
              <Divider />
              <List component='nav'>
                {sections.map((section) => (
                  <ListItem
                    button
                    key={section.id}
                    selected={selectedSection.id === section.id}
                    onClick={() => setSelectedSection(section)}
                    className={
                      selectedSection.id === section.id
                        ? classes.selectedItem
                        : ''
                    }
                  >
                    <ListItemText primary={section.title} />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>

        {/* Content */}
        <Grid item xs={12} md={9} style={{ height: '100%' }}>
          <Card className={classes.contentCard} variant='outlined'>
            <CardContent>
              <div className={classes.contentContainer}>
                <Typography variant='h4' gutterBottom>
                  {selectedSection.title}
                </Typography>
                <Divider style={{ marginBottom: '1.5rem' }} />
                <Markdown value={selectedSection.content} />
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}
